import { FilePointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (): FilePointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.FILE_POINTER,
  variable: null,
});
